import React, { useEffect, useMemo, useRef, useState } from 'react'
import { RxTriangleRight } from 'react-icons/rx'
import { useNavigate } from 'react-router-dom'
import Circle from '../CenterCircle/Circle'
import CircleMobil from '../CenterCircle/CircleMobile'
import styles from "./Service.module.css"
export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])


    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])
    // //console.log(isInters ecting);
    return isIntersecting
}
function Service() {
    const navigate = useNavigate()
    const ref = useRef()
    const ref1 = useRef()


    return (
        <div className={styles.Service}>
            <h3 style={{ color: "#066263" }}>Service</h3>

            <div className={styles.Servicemain}>
                <div className={styles.ServiceLeft}>
                    <h4>私たちが提供するもの</h4>
                    <div className={styles.puffincenter}>
                        <p>株式会社SHARVIL が提供することができるものは多岐にわたります。</p>
                        <br />
                        <p>ITのリソースが豊富なインドを拠点として、10年以上のIT業界における経験を活用したソリューションを提供できます。また、ITのソリューションの活用方法を熟知した経験豊富なコンサルタントがそれらのソリューションと合わさり、顧客の抱える課題をシンプルかつ効率的に解決します。</p>
                        <br />

                        <p>株式会社SHARVIL のもつ世界中のネットワークは顧客の新たな事業領域の開発、世界市場への進出をサポートできます。
                        </p>
                    </div>
                </div>
                <div ref={ref1} className={`${styles.ServiceRight}`}>

                    <Circle />
                    <CircleMobil/>
                </div>

            </div>
            <div className={`${styles.WwhyUsbutton} mobileButton`}>
                <button onClick={() => navigate('/service-work')}>Services<RxTriangleRight /></button>

            </div>
        </div>
    )
}

export default Service